import React from "react";
import "./divider.css";

function Divider() {
  return <div className="divider" />;
}

export default Divider;
